export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtZpracovOsDat';
export const NAME = 'SpravciOsobnichUdaju';

export const enum GDPR_SOUHLAS_TXT {
	C1 = 0,
	C2 = 1,
	C3 = 2,
}
